import { useState } from "react";
import { cancelBonus } from "../../../data/wallet";
import { showErrorToast, showSuccessToast } from "../../../actions/helper";
import { Button, Col, Modal, Spin } from "antd";
import PromotionOneWalletModal from "../../../pages/PromotionOneWalletModal";

export default function SignUpPreBonusCancelForm({item, visible, handleClose, PreBonusFormProps, callbackAfterCancel=() => {}}) {
    const [modalProps, setModalProps] = useState({});
    const [apiError, setApiError] = useState({});
    const [showErorModal, setShowErrorModal] = useState(false);
    const [checked, setChecked] = useState(false);
    console.log("SignUpPreBonusCancelFormItem", item, PreBonusFormProps);
    const[isLoading, setIsLoading] = useState(false);
    const handleCheckboxChange = () => {
        setChecked((prev) => !prev);
    };
    const onClose = () => {
        setShowErrorModal(false);
        setApiError({});
        setModalProps({});
        setChecked(false);
        handleClose();
    };
    const handleSubmitForm = async () => {
        console.log("SignUpPreBonusCancelForm", item);
        console.log("item?.playerBonusId", item?.playerBonusId);
        
        setIsLoading(true);
    
        if (item?.playerBonusId) {
            try {
                let cancelRsp = await cancelBonus(item?.playerBonusId);
                if (cancelBonus.isCancelSuccess(cancelRsp)) {
                    callbackAfterCancel();
                    showSuccessToast("Đã hủy");
                } else {
                    showErrorToast("Hủy bỏ không thành công", <img src="/vn/img/1wallet/00/toast-red-cross.svg" alt="toast-red-cross" />);
                }
            } catch (error) {
                showErrorToast();
            } finally {
                setIsLoading(false);
                onClose();
            }
        } else {
            setIsLoading(false);
        }
    };
    
    // const handleSubmitForm = async () => {
    //     console.log("SignUpPreBonusCancelForm", props);
    //     console.log(
    //         "item?.playerBonusId",
    //         item?.playerBonusId
    //     );
    //     setIsLoading(true);
    //     if (item?.playerBonusId) {
    //         let cancelRsp = await cancelBonus(
    //             item?.playerBonusId
    //         );
    //         if (cancelBonus.isCancelSuccess(cancelRsp)) {
    //             toast.success("Khuyến mãi đã bắt đầu.", {
    //                 style: { minHeight: "30px", padding: "0px" },
    //                 position: "top-center",
    //                 autoClose: 2000,
    //                 hideProgressBar: true,
    //                 closeOnClick: true,
    //                 pauseOnHover: false,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "light",
    //                 transition: Zoom,
    //                 closeButton: false, // Hide the close icon
    //                 icon: (
    //                     <img
    //                         src="/vn/img/1wallet/00/successToastIcon.svg"
    //                         alt="icon-success"
    //                     />
    //                 ),
    //                 className: "custom-toast-OW-project",
    //             });
    //             setIsLoading(false);
    //             onClose();
    //         } else {
    //             toast.error(
    //                 "Hệ thống hiện không khả dụng vì lý do nội bộ, xin vui lòng thử lại sau",
    //                 {
    //                     style: { minHeight: "30px", padding: "0px" },
    //                     position: "top-center",
    //                     autoClose: 2000,
    //                     hideProgressBar: true,
    //                     closeOnClick: true,
    //                     pauseOnHover: false,
    //                     draggable: true,
    //                     progress: undefined,
    //                     theme: "light",
    //                     transition: Zoom,
    //                     closeButton: false, // Hide the close icon
    //                     icon: (
    //                         <img
    //                             src="/vn/img/1wallet/00/info-yellow.svg"
    //                             alt="info-yellow"
    //                         />
    //                     ),
    //                     className: "custom-toast-OW-project yellowInfo",
    //                 }
    //             );
    //             setIsLoading(false);
    //             onClose();
    //         }
    //     }
    //     setIsLoading(false);
    // };

    const {
        pullbackAmount = 0,
        bonusGiven = 0,
        bonusGivenAmount = 0,
    } = PreBonusFormProps || {};
    return (
    <Modal visible={visible} footer={null} closable={false} width={426}>
    <div className="PromotionManualPromotionApplicationForm">
        <Spin spinning={isLoading}>
            <div className="PromotionManualPromotionApplicationForm">
                <span
                    onClick={() => {
                        onClose();
                    }}
                    style={{
                        position: "absolute",
                        top: "15px",
                        right: "-3px",
                        zIndex: "10",
                        cursor: "pointer",
                    }}
                >
                    <img
                        src="/vn/img/1wallet/00/ModalCloseIcon.svg"
                        alt="Close Icon"
                    />
                </span>
                <Col
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "15px",
                    }}
                >
                    <div
                        style={{
                            marginTop: "55px",
                            textAlign: "center",
                            fontSize: "20px",
                            fontWeight: "600",
                            color: "#222222",
                        }}
                    >
                        Quan trọng
                    </div>
                </Col>
                <Col
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "15px",
                    }}
                >
                    <img
                        src="/vn/img/1wallet/00/OWCancelFlowIcon.svg"
                        alt="OWCancelFlowIcon"
                    />
                </Col>
                <Col
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        marginBottom: "15px",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            padding: "0 10px",
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#666666",
                            width: "100%",
                        }}
                    >
                        {PreBonusFormProps?.isNoBet2WinLose
                            ? `Việc hủy bỏ Ưu đãi này sẽ thu hồi thưởng trước trả ${pullbackAmount} đ`
                            : `Việc hủy bỏ Ưu đãi sẽ thu hồi ${pullbackAmount} đ`}
                    </div>
                </Col>
                <hr
                    style={{
                        width: "90%", // Slightly narrower to leave some padding
                        height: "1px", // Thin line
                        backgroundColor: "#E0E0E0", // Light gray color
                        border: "none", // Remove default border
                        margin: "10px auto", // Center the divider with spacing
                        borderRadius: "5px", // Smooth edges
                        marginBottom: "15px",
                        marginTop: "15px",
                    }}
                />
                {PreBonusFormProps?.isNoBet2WinLose && (
                    <Col
                        style={{
                            marginBottom: "15px",
                            // backgroundColor: "#EFEFF4",
                            fontSize: "12px",
                            fontWeight: "400",
                            padding: "10px 15px",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            Doanh thu tích lũy trong Thời gian Khuyến mãi sẽ
                            không còn hiệu lực.
                        </div>
                    </Col>
                )}
                {PreBonusFormProps?.isWin && (
                    <Col
                        style={{
                            color: "#666666",
                            fontSize: "14px",
                            fontWeight: "400",
                        }}
                    >
                        <ul>
                            <li>
                                1. Việc hủy bỏ khuyến mãi này sẽ thu hồi
                                thưởng trả trước{" "}
                                <span style={{ color: "#222222" }}>
                                    {bonusGivenAmount}
                                </span>{" "}
                                đ và các khoản thắng liên quan{" "}
                                <span style={{ color: "#222222" }}>
                                    {winningAmount}
                                </span>{" "}
                                đ. Doanh thu tích lũy trong Thời gian Khuyến
                                mãi sẽ không còn hiệu lực.
                            </li>
                            <li>
                                2. Việc hủy bỏ khuyến mãi này sẽ thu hồi
                                thưởng trả trước 200 đ và các khoản thắng
                                liên quan 200 đ. Doanh thu tích lũy trong
                                Thời gian Khuyến mãi sẽ không còn hiệu lực.
                            </li>
                        </ul>
                    </Col>
                )}

                {PreBonusFormProps?.isLose && (
                    <Col
                        style={{
                            color: "#666666",
                            fontSize: "14px",
                            fontWeight: "400",
                        }}
                    >
                        Doanh thu tích lũy trong Thời gian Khuyến mãi sẽ
                        không còn hiệu lực.
                    </Col>
                )}

                <Col
                    style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "#666666",
                        marginBottom: "20px",
                    }}
                >
                <div className="checkbox-container-OW">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={handleCheckboxChange}
                        style={{
                            width: "16px",
                            height: "16px",
                            marginRight: "8px",
                        }}
                    />
                    <label
                        onClick={handleCheckboxChange}
                        style={{ cursor: "pointer" }}
                    >
                        Tôi đã đọc nội dung trên và{" "}
                        <strong style={{ color: "#222222" }}>
                            đồng ý hủy bỏ ưu đãi.
                        </strong>
                    </label>
                </div>
                </Col>
                <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                    <Button
                        style={{
                            color: !checked ? "#999999" : "#FFFFFF",
                            backgroundColor: !checked
                                ? "#E3E3E3"
                                : "#00A6FF",
                        }}
                        disabled={isLoading || !checked}
                        className="PromotionManualPromotionApplicationForm-submit"
                        // disabled={userInputAmount === 0}
                        onClick={() => {
                            // handleClose();
                            handleSubmitForm();
                        }}
                    >
                        Xác nhận
                    </Button>
                </Col>
                <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                    <Button
                        style={{
                            marginTop: "10px",
                            color: "#00A6FF",
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #00A6FF",
                        }}
                        className="PromotionManualPromotionApplicationForm-submit"
                        onClick={() => {
                            onClose();
                            // handleSubmitForm();
                        }}
                    >
                        Quay lại
                    </Button>
                </Col>
                <PromotionOneWalletModal
                    isVisible={showErorModal}
                    config={apiError}
                    onClose={onClose}
                    props={modalProps}
                />
            </div>
        </Spin>
    </div>
    </Modal>
    );
}